export default "__VITE_ASSET__066172d1__"